<script>
import ModuleTitle from '../common/ModuleTitle.vue'

export default {
  name: 'Comp12',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<template>
  <div class="modules-id-12">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-12-content pointer">
      <el-image
        v-if="moduleOption.list[0] && moduleOption.list[0].photo"
        :src="moduleOption.list[0].photo | imgPath"
        alt="activity"
        class="framework-img"
        fit="cover"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-12-content {
  display: flex;
  justify-content: center;
  .framework-img {
    width: 455px;
    max-height: 325px;
  }
}
</style>
